import { ref } from "vue"


const keepKey = ref(0)

export const useKeepKeyEffect = () => {
    const clearAllKeepAlive = () => {
        keepKey.value++
    }
    return { keepKey, clearAllKeepAlive }
}

const isReport = ref(false)
export const useReportEffect = () => {
    const showReportUI = () => {
        isReport.value = true
    }
    const hideReportUI = () => {
        isReport.value = false;
    }

    return { showReportUI, hideReportUI, isReport }
}
